export class DonationsReport {
    RefCodeID :number=null as any;
    RefCode :string=null as any;
    ProjectName:string=null as any
    Project:number=null as any
    FromDate:string=null as any
    ToDate:string=null as any
    
}
